<template>
  <div class="h-32 w-full flex items-center justify-center" v-if="buildingsIsLoading">
    <Spinner />
  </div>
  <div v-else>
    <div class="flex py-4">
      <button class="bg-kas-500 p-3 rounded flex flex-row text-white space-x-2 mr-2"
              :class="{ 'bg-opacity-50': mode !== 'cards' }"
              @click="mode = 'cards'">
        <i class="icon icon-grid"></i>
        <span class="hidden md:inline-block">Näytä kortteina</span>
      </button>

      <button class="bg-kas-500 p-3 rounded flex flex-row text-white space-x-2"
              :class="{ 'bg-opacity-50': mode !== 'map' }"
              @click="mode = 'map'">
        <i class="icon icon-globe"></i>
        <span class="hidden md:inline-block">Näytä kartalla</span>
      </button>

      <!--
      <button class="bg-kas-500 p-2 font-bold text-white rounded" :class="{ 'bg-opacity-50': mode !== 'cards' }"
              @click="mode = 'cards'">Näytä kortteina
      </button>
      <button class="bg-kas-500 p-2 font-bold text-white rounded" :class="{ 'bg-opacity-50': mode !== 'map' }"
              @click="mode = 'map'">Näytä kartalla
      </button>
      -->
      <div class="ml-auto grid grid-cols-2 gap-2">
        <div>
          <button class="bg-kas-100 font-bold text-sm text-kas-500 px-4 py-2" v-if="buildings.links.prev" @click="toPage(buildings.links.prev)">
            <span>Edellinen sivu</span>
          </button>
        </div>
        <div class="text-right">
          <button class="bg-kas-500 font-bold text-sm text-white px-4 py-2" v-if="buildings.links.next" @click="toPage(buildings.links.next)">
            <span>Seuraava sivu</span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="buildings">
      <div v-if="buildings.data.length === 0">
        <div class="bg-kas-100 bg-opacity-50">
          <div class="px-4 py-5 sm:p-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Ei hakutuloksia
            </h3>
            <div class="mt-5">
              <button @click="$emit('resetOptions')"
                      type="button"
                      class="inline-flex items-center px-4 py-2 border-0 shadow-sm font-medium text-kas-100 bg-kas-500 hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-kas-500 sm:text-sm">
                Tyhjennä haku
              </button>
            </div>
          </div>
        </div>
      </div>

      <Map v-if="mode === 'map'" :markers="markers"/>

      <div v-if="mode === 'cards'" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 pt-8">
        <div v-for="building in buildings.data" :key="buildings.id">
          <a :href="building.uri">
            <div class="h-48 w-full overflow-hidden relative">
              <img class="object-cover h-48 w-full"
                   style="clip-path: polygon(0% 25%, 100% 0%, 100% 100%, 0% 100%)"
                   :src="building.images?.main?.small ?? 'https://kas.fi/assets/themes/kas/resources/assets/images/no-pic.png'"
                   :alt="building.street_address" />
            </div>

            <div class="border border-gray-300 border-t-0">
              <div class="p-2">
                <h1 class="font-bold text-kas-500 text-lg">{{ building.street_address }}</h1>
                <p class="font-medium text-gray-600 text-sm">{{ building.post_office }}</p>
              </div>

              <div class="border-t border-gray-300 p-2">
                <h2 class="font-bold text-gray-600 text-sm">Huoneistotyypit</h2>
                <div class="flex items-center text-gray-600 text-sm" v-for="({ amount, areas }, type) in building.types" :key="type">
                  <div class="">{{ type }}</div>
                  <div class="px-2 text-xs flex-1">{{ areas }}</div>
                  <div class="flex-grow-0 flex-shrink-0 text-right w-10">{{ amount }}</div>
                </div>
              </div>
            </div>

            <div class="">
              <a :href="building.uri" class="block font-bold bg-kas-500 text-center text-white py-2">
                Näytä lisätietoja
              </a>
            </div>
          </a>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-2 pt-8 ok">
        <div>
          <button class="bg-kas-100 font-bold text-sm text-kas-500 px-4 py-2" v-if="buildings.links.prev" @click="toPage(buildings.links.prev)">
            <span>Edellinen sivu</span>
          </button>
        </div>
        <div class="text-right">
          <button class="bg-kas-500 font-bold text-sm text-white px-4 py-2" v-if="buildings.links.next" @click="toPage(buildings.links.next)">
            <span>Seuraava sivu</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Map from './Map'
import Spinner from './Spinner';
import useBuildings from '../use/buildings.js'
import { computed, ref } from "vue";

export default {
  name: 'BuildingList',
  components: { Map, Spinner },
  props: {
    city: {
      required: false,
      default: () => null,
      type: String
    },
    buildingTypes: {
      required: false,
      default: () => [],
      type: Array
    },
    numberOfRooms: {
      required: false,
      default: () => [],
      type: Array
    }
  },
  setup(props) {
    const { buildings, buildingsIsLoading, toPage } = useBuildings(props)

    const mode = ref('cards')

    const markers = computed(() => {
      return buildings.value?.data.flatMap(item => {
        return item.coordinateSets?.map(set => {
          return {
            id: item.id,
            coordinates: set,
            uri: item.uri
          }
        }) ?? []
      }).filter(({ coordinates }) => coordinates) ?? []
    })

    return {
      buildings,
      buildingsIsLoading,
      toPage,
      mode,
      markers
    }
  }
}
</script>
